import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Context } from '../..';
import AuthService from '../../services/AuthService';
import { ModalPopoverRightTop } from '../pages/modal/modal-popover-rt';
import { PrivPolModal } from './PrivacyPolicyModal';


const Lang: FC = () => {

    const { store } = useContext(Context);

    return (
        <div>
            <table className="table">
                <tbody style={{ cursor: "pointer" }}>
                    <tr onClick={() => store.setLang("ba")}>
                        <td>Башҡортса</td>
                    </tr>
                    <tr onClick={() => store.setLang("ru")}>
                        <td>Русский</td>
                    </tr>
                    <tr onClick={() => store.setLang("en")}>
                        <td>English</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};


const PasswordReset: FC = () => {
    const { uid, token } = useParams();
    const [new_password, setNewPassword] = useState<string>('');
    const [privPolModal, setPrivPolModal] = useState<boolean>(false);
    const [langToggle, setLangToggle] = useState<boolean>(false);
    const { store } = useContext(Context);
    const [data, setData] = useState({});
    const [see, setSee] = useState(false);
    const navigate = useNavigate();


    if (document.getElementById('password') as HTMLInputElement) {
        if (see) {
            (document.getElementById('password') as HTMLInputElement).type = 'text'
        } else {
            (document.getElementById('password') as HTMLInputElement).type = 'password'
        }
    };

    useEffect(() => {
        setData({ new_password, uid, token })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [new_password]);

    const resetPass = async () => {
        try {
            await AuthService.passwordReset(data);
            alert(store.lang === 'ba' ? 'Пароль ташланды' : store.lang === 'ru' ? 'Пароль сброшен' : 'Password reset')
            navigate('/login')
        } catch (e) {
            console.log(e);
            alert(store.lang === 'ba' ? 'Хата' : store.lang === 'ru' ? 'Ошибка' : 'Error')
        }
    }


    return (<>
        <div className="row justify-content-end">
            <div className="col-2">
                <Link className="nav-link text-dark" to="" onClick={() => setLangToggle(true)}><i className='icon dark-language' /><Trans>English</Trans></Link>
            </div>
        </div>

        <div className="row justify-content-center">
            <div className="col-2">
                <Link className="nav-link text-light" to="/">
                    <img src='/images/morb.png' alt='logo' className='login-form-logo' />
                </Link>
            </div>
        </div>

        <form className='row mt-5'>
            <div className='mb-4 row justify-content-center'>
                <label className="form-label col-4 col-md-2 text-end"><Trans>New password</Trans></label>
                <div className="col-6 col-md-3 d-flex">
                    <input
                        id='password'
                        className="form-control"
                        onChange={e => setNewPassword(e.target.value)}
                        value={new_password}
                    />
                    <div style={{ position: 'relative' }}><i className={'icon' + (see ? ' see' : ' unsee') + ' absolute'} onClick={() => setSee(!see)} /></div>
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className="col-6 col-md-2">
                    <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={resetPass}
                    ><Trans>Reset Password</Trans></button>
                </div>
            </div>
        </form>
        <ModalPopoverRightTop
            toggle={langToggle}
            setToggle={setLangToggle}
            title={store.lang === 'ba' ? 'Телде һайлағыҙ' : store.lang === 'ru' ? 'Выберите язык' : 'Сhoose the language'}
            modalContent={<Lang />}
            clickedButtonOne={() => { }}
            clickedButtonTwo={() => setLangToggle(false)}
            ButtonOneValue=''
            ButtonTwoValue=''
        />
        <PrivPolModal toggle={privPolModal} setToggle={setPrivPolModal} />
    </>
    )
};
export default observer(PasswordReset);